import { useQueryParam } from './useIsQueryParam';

export function useIsOverlay() {
    const isOverlay = useQueryParam('overlay');
    if (!isOverlay) return false;

    return parseInt(isOverlay) === 1;
}
